import update from 'immutability-helper';
import { createReducer } from 'redux-create-reducer';
import actionsAndConstants from '../../shared/actionsAndConstants';

const {
  techniciansReportForm: { constants: techniciansReportFormConstants },
  topNavbar: { constants: topNavbarConstants }
} = actionsAndConstants;

const initialState = {
  form: {
    lastEtir: null,
    submitted: false,
  }
};

const createRegistrySucceeded = (state, { payload = {} }) => {
  const { registryId = null } = payload;
  return update(state, {
    form: {
      lastEtir: { $set: registryId },
      submitted: { $set: true }
    }
  });
};

const logoutSucceeded = () => initialState;

const usersReducer = createReducer(initialState, {
  [techniciansReportFormConstants.createRegistry]: logoutSucceeded,
  [techniciansReportFormConstants.createRegistrySucceeded]: createRegistrySucceeded,
  [topNavbarConstants.logoutSucceeded]: logoutSucceeded
});

export default usersReducer;



// WEBPACK FOOTER //
// ./src/containers/TechniciansReportForm/reducer.js